import BaseStorage from "./BaseStorage";
import UserData from "../data/UserData";
import type { UserRawData } from "../data/UserData";

/**
 * Storage service for user data.
 *
 * Use localStorage or sessionStorage depending on status.
 *
 * Implements most Storage methods plus some utility functions.
 */
class UserStorage extends BaseStorage {

    // All names like 'user.xxx'
    static keyPrefix = 'user';

    /**
     * Gets storage object.
     */
    static storage(): Storage {
        return window.localStorage;
    }

    /**
     * Gets User Data from storage.
     *
     * OJO: hoy no lo llama nadie. El getUserData que usa el menu es el de
     * SiteAuth, que es otro metodo distinto.
     */
    static getUserData(keyName: string): UserData | null {
      const rawData = this.getObject<UserRawData>(keyName);

      if (rawData) {
        return UserData.fromRawData(rawData);
      }

      return null;
    }

}

export default UserStorage;
